/* eslint-disable import/no-anonymous-default-export */
import environment from '../environments/Environment';
import HttpService from './HttpService';
import HttpServiceNoToken from './HttpServiceNoToken';
export default {
    editCustomize(payload) {
        return HttpService.put(environment.API_DS_REQUEST_FORM, payload);
    },
    getCustomize(payload) {
        return HttpService.get(environment.API_DS_REQUEST_FORM + `/${payload}`);
    },
    getPublicCustomize(payload) {
        return HttpService.get(
            environment.API_PUBLIC_DS_REQUEST_FORM + `/${payload}`,
            {
                transformRequest: (data, headers) => {
                    delete headers['Authorization'];
                    return data;
                },
            }
        );
    },
    getMasterDsRequuestForm(domainId) {
        return HttpServiceNoToken.get(
            environment.API_MASTER_DS_REQUEST_FORM + `/${domainId}`
        );
    },
    submitForm(payload) {
        return HttpServiceNoToken.post(
            environment.API_NOSECURE_DS_REQUEST_FORM,payload
        );
    },
    checkWorkflow(dsrTaskId) {
        return HttpService.get(
            environment.API_CHECK_WORKFLOW_STEP + `/${dsrTaskId}`
        );
    },
    addDataSubject(payload) {
        return HttpService.post(
            environment.API_DS_REQUEST_FORM + '/data-subject/add-on',
            payload
        );
    },
};
